import { Link, useNavigate } from "react-router-dom";
import moment from 'moment';
import 'moment/locale/pt-br'
import api from "../../services/api.js";
import { useEffect, useState } from "react";
import { dadosLogin } from "../../zustand/zuztand.js";

import "../aniversario-franqueados-mobile/aniversario-franqueados-mobile.css";
import AniverCard from "../../components/aniver-franqueados-mobile/aniver-franqueados-mobile.jsx";

function AniversarioFranqueadosMobile() {

  const navigate = useNavigate();
  const { ifLogado, usuario, nivel_user } = dadosLogin()

  const local = moment().locale('pt-br').format('LL'); //converte a data par pt-br   ex: 12 de setembro de 2024 
  const mesAtuals = (local.split(" ")[2]); // converte 12 de setembro de 2024  em array e pega o indice 2 (mes extenço)
  const [dados, setDados] = useState([]);


  var Xmas95 = new Date();
  var month = Xmas95.getMonth();
  var mesAtual = month + 1;

  function PesquisarAniverFranqueados() {

    let novo_array = [];

    api.get("/franqueados_busca")
      .then((resp) => {
       //console.log(resp.data)
        resp.data.map((item) => {
          let dtaAniver = parseInt(item.data_nasc_franqueado.substring(3, 5));

          if (dtaAniver === mesAtual) {
            novo_array.push({
              id: item.id_franqueado,
              nome: item.nome_franqueado,
              img: item.img_franqueado,
              data: item.data_nasc_franqueado
            })
          }
        })
       // console.log(novo_array)
        setDados(novo_array);
      })
      .catch((err) => {
        setDados([]);
        alert("Erro ao carregar dados");
      });
  }

  useEffect(() => {
    PesquisarAniverFranqueados();

  }, []);

  return <>
    <div className="d-flex container-fundo-franqueado">
      <div className="d-block container-body-franqueado">
        {
          ifLogado !== "notLogad" ? <>

            <div className="d-flex justify-content-between">
              <div className="col-1">
              </div>
              <h4 className="ms-3 mt-2">
                Aniver Franqueados: {mesAtuals}
              </h4>
              <Link to="/dashboard-mobile" className="btn btn-success p-2 me-5 mt-2 btn-sm" >Voltar </Link>
            </div>  

            <div className="coluna-aniversariantes-franqueado-mob">
            {
              dados.map((item) => {
                return <AniverCard
                  key={item.id_franqueado}
                  nome={item.nome}
                  data={item.data}
                  img={item.img}
                />
              })
            }
            </div>
          </> : navigate('/login')
        }
      </div>
    </div>
  </>
}
export default AniversarioFranqueadosMobile;